const LAST_COMPANY_KEY = "lastCompany";

/**
 * Persist the last company (dossier) accessed by a client user with access to
 * more than one dossier. Stored per user so switching accounts does not leak
 * the previous user's default.
 */
export function getLastCompany(userId?: ID): string | undefined {
  if (!userId) return undefined;
  try {
    const raw = localStorage.getItem(`${LAST_COMPANY_KEY}_${userId}`);
    return raw ?? undefined;
  } catch {
    return undefined;
  }
}

export function setLastCompany(userId: ID | undefined, companyId: ID): void {
  if (!userId || !companyId) return;
  try {
    localStorage.setItem(`${LAST_COMPANY_KEY}_${userId}`, String(companyId));
  } catch {
    // ignore storage errors (e.g. private mode / quota)
  }
}
